import React, { createContext, useContext, useEffect, useState } from "react";
import { setVisualMode } from "../utils/visualMode";

const VisualModeContext = createContext({
  mode: "full",
  isMinimal: false,
  setMode: () => {},
});

export function VisualModeProvider({ children }) {
  const [mode, setModeState] = useState("full");

  useEffect(() => {
    let saved = null;
    try {
      saved = localStorage.getItem("bbx:visual-mode");
    } catch {}
    const initial = saved === "minimal" ? "minimal" : "full";
    setModeState(initial);
    setVisualMode(initial);
  }, []);

  const setMode = (next) => {
    const normalized = next === "minimal" ? "minimal" : "full";
    setModeState(normalized);
    setVisualMode(normalized);
  };

  return (
    <VisualModeContext.Provider
      value={{ mode, isMinimal: mode === "minimal", setMode }}
    >
      {children}
    </VisualModeContext.Provider>
  );
}

export function useVisualMode() {
  return useContext(VisualModeContext);
}
